/**
 * @see https://developers.google.com/maps/documentation/geocoding/overview#Types
 */
export enum AutocompletePredictionTypes {
  ROUTE = 'route',
  GEOCODE = 'geocode',
  STREET_ADDRESS = 'street_address',
  LOCALITY = 'locality',
  SUBLOCALITY = 'sublocality',
  NEIGHBORHOOD = 'neighborhood',
  POSTAL_CODE = 'postal_code',
  COUNTRY = 'country',
  SUBLOCALITY_LEVEL_1 = 'sublocality_level_1',
  ADMINISTRATIVE_AREA_LEVEL_1 = 'administrative_area_level_1',
  ADMINISTRATIVE_AREA_LEVEL_2 = 'administrative_area_level_2',
  ADMINISTRATIVE_AREA_LEVEL_3 = 'administrative_area_level_3',
  POINT_OF_INTEREST = 'point_of_interest'
}

export enum AutocompletePredictionPredictionCategory {
  CITY = 'city',
  NEIGHBORHOOD = 'neighbourhood',
  STREET = 'street',
  PROVINCE = 'province',
  MILITARY = 'military',
  POSTAL_CODE = 'postal code',
  OTHER = 'other'
}

/**
 * @see https://developers.google.com/maps/documentation/places/web-service/supported_types#table3
 */
export enum AutocompletePredictionRestrictionTypes {
  CITIES = '(cities)',
  REGIONS = '(regions)',
  GEOCODE = 'geocode',
  ADDRESS = 'address',
  POINT_OF_INTEREST = 'point_of_interest'
}

export type QueryResultType = {
  city: google.maps.places.AutocompletePrediction[];
  neighborhood: google.maps.places.AutocompletePrediction[];
  street: google.maps.places.AutocompletePrediction[];
  province: google.maps.places.AutocompletePrediction[];
  postalCode: google.maps.places.AutocompletePrediction[];
};

export type GoogleAutocompleteProviderType = (
  input: string
) => Promise<QueryResultType>;

export type QuerySettingsLimitType = {
  city: number;
  neighborhood: number;
  street: number;
  province: number;
};

export type QuerySettingsType = {
  limits: QuerySettingsLimitType;
};

export enum SearchPredictionSource {
  GOOGLE = 'google',
  GO_SEARCH = 'go-search'
}